import { useState } from 'react';

const useDebounce = (): ((callback: () => void, msecs: number) => void) => {
  const [timeOut, setTimeOut] = useState<any>(undefined);

  return (callback: () => void, msecs: number) => {
    if (timeOut) {
      clearTimeout(timeOut);
    }
    setTimeOut(setTimeout(callback, msecs));
  };
};

export default useDebounce;
